import { render, staticRenderFns } from "./CardStacked.vue?vue&type=template&id=af3e38d8&scoped=true&"
import script from "./CardStacked.vue?vue&type=script&lang=js&"
export * from "./CardStacked.vue?vue&type=script&lang=js&"
import style0 from "./CardStacked.vue?vue&type=style&index=0&id=af3e38d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_rqhk6tgffcjxa27soxhh2o2ymu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3e38d8",
  null
  
)

export default component.exports